import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import MonthlyProductUsage from './monthly-product-usage';
import MonthlyProductUsageDetail from './monthly-product-usage-detail';
import MonthlyProductUsageUpdate from './monthly-product-usage-update';
import MonthlyProductUsageDeleteDialog from './monthly-product-usage-delete-dialog';

const MonthlyProductUsageRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<MonthlyProductUsage />} />
    <Route path="new" element={<MonthlyProductUsageUpdate />} />
    <Route path=":id">
      <Route index element={<MonthlyProductUsageDetail />} />
      <Route path="edit" element={<MonthlyProductUsageUpdate />} />
      <Route path="delete" element={<MonthlyProductUsageDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default MonthlyProductUsageRoutes;
